export default "__VITE_ASSET__0g4aQ60P__"